import { Field, NativeSelect } from "@chakra-ui/react";
import i18next from "i18next";
import { AttributeDefinitions, AttributeSelect } from "@keita/lanepatrol-sdk";
import { SelectAttributeFilter } from "../../../../../map/models/MapFilters";
import { AttributeUtils } from "../../../../../coding/utils/attribute-utils";

interface Props {
  setValue: (value: any) => void;
  attributeFilter: SelectAttributeFilter;
}

export const SelectFilter: React.FC<Props> = ({
  setValue,
  attributeFilter,
}) => {
  const attributeDefinition = AttributeDefinitions.getByName(
    attributeFilter.attributeName
  ) as AttributeSelect;

  return (
    <Field.Root mt={1} mb={2} display="flex" alignItems="center">
      <NativeSelect.Root>
        <NativeSelect.Field
          placeholder={i18next.t(`map:filters.selectPlaceholder`)}
          value={attributeFilter.value}
          onChange={(e) => {
            const { value } = e.target;
            setValue({ value });
          }}
        >
          {attributeDefinition.options!!.map((option, i) => {
            return (
              <option key={i} value={option.value}>
                {AttributeUtils.getOptionLabel(option.value)}
              </option>
            );
          })}
        </NativeSelect.Field>
        <NativeSelect.Indicator />
      </NativeSelect.Root>
    </Field.Root>
  );
};
